export class MediaUsedOnDeletionError extends Error {

  constructor({ title, type, message }) {
    super(message)
    this.title = title
    this.type = type
  }

}
